import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { Autocomplete } from '@emburse/ui-core';
const getCategoryLabel = (category) => category.name;
const CategorySelector = ({ categories, selectedCategoryId, onCategorySelect, loading, disabled }) => {
    const flattenedCategories = React.useMemo(() => categories.reduce((accumulator, category) => {
        if (category.subcategories) {
            accumulator.push(...category.subcategories.map((subcategory) => (Object.assign(Object.assign({}, subcategory), { name: `${category.name} / ${subcategory.name}` }))));
        }
        else {
            accumulator.push(category);
        }
        return accumulator;
    }, []), [categories]);
    let selected = flattenedCategories.find(({ id }) => id === selectedCategoryId) || null;
    if (disabled) {
        selected = null;
    }
    React.useEffect(() => {
        // Clear out selected category if it is not included within provided options.
        //  Setting new selection by value property does not trigger onChange event
        //  so we need to do it manually.
        if (!loading && selectedCategoryId !== (selected === null || selected === void 0 ? void 0 : selected.id) && categories.length) {
            onCategorySelect(null);
        }
    }, [categories, selectedCategoryId]);
    return (_jsx(Autocomplete, { label: "Category", value: selected, options: flattenedCategories, getOptionLabel: getCategoryLabel, onChange: (_, value) => onCategorySelect(value), disabled: disabled }));
};
const MemoizedCategorySelector = memo(CategorySelector);
export { MemoizedCategorySelector as CategorySelector };
